module.exports = {
          srcSet: __webpack_public_path__ + "public/9e9727e6b311c480cba5996a61811be6-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/9e9727e6b311c480cba5996a61811be6-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/9e9727e6b311c480cba5996a61811be6-80.png",
          toString:function(){return __webpack_public_path__ + "public/9e9727e6b311c480cba5996a61811be6-80.png"},
          
          width: 80,
          height: 80
        }